// @flow
import { Schema } from "../../../components/form";

const formSchema = new Schema({
  terms: {
    type: "boolean"
  }
});

export default formSchema;
